import React from 'react';
import { Steps } from 'antd/lib';
import FormVerificacionAutorizacionMenor from './TrabajoMenoresPublic';
import getAutorizacionTrabajoByCodigoUnico from '../../../graphql/querys/tramites/getAutorizacionTrabajoByCodigoUnico.graphql';
import getMinioUrlAutorizacionTrabajo from '../../../graphql/querys/tramites/getMinioUrlAutorizacionTrabajo.graphql';
import { graphql, compose, withApollo } from 'react-apollo';
import VisualizarAutorizacionTrabajoMenor from './TrabajoMenoresVisualizerPublic';
import { withRouter } from 'react-router-dom';

const Step = Steps.Step;

@compose(
  graphql(getAutorizacionTrabajoByCodigoUnico, {
    name: 'getAutorizacionTrabajoByCodigoUnico',
  })
)
class FormVerificacionAutorizacionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fase: 0,
      autorizacionEncontrada: null,
      loading: false,
      error: null
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    // Check if we have a code in the URL
    const { match } = this.props;
    if (match && match.params && match.params.codigo) {
      const codigo = match.params.codigo;
      console.log('Found code in URL:', codigo);
      
      // Search with the URL parameter
      this.searchByUrlParam(codigo);
    }
  }

  // New method to handle URL parameter searches
  searchByUrlParam = async (codigo) => {
    try {
      this.setState({ loading: true, error: null });
      
      const esAutorizada = await this.buscarAutorizacion({
        codigoAuth: codigo
      });
      
      if (esAutorizada) {
        console.log('Authorization found from URL param:', esAutorizada);
        this.setState({
          fase: 1,
          autorizacionEncontrada: esAutorizada,
          loading: false
        });
      } else {
        this.setState({ 
          loading: false, 
          error: "No se encontró autorización con el código proporcionado"
        });
      }
    } catch (error) {
      console.error("Error searching by URL param:", error);
      this.setState({ 
        loading: false, 
        error: "Error al buscar la autorización"
      });
    }
  }

  async onSubmit(idAutorizacion) {
    this.setState({ loading: true, error: null });
    
    const esAutorizada = await this.buscarAutorizacion(idAutorizacion);
    if (esAutorizada) {
      
      console.log("🚀 ~ FormVerificacionAutorizacionContainer ~ onSubmit ~ esAutorizada:", esAutorizada)
      this.setState({
        fase: 1,
        autorizacionEncontrada: esAutorizada,
        loading: false
      });
    } else {
      this.setState({ 
        loading: false, 
        error: "No se encontró autorización con el código proporcionado"
      });
    }
  }
  buscarAutorizacion = async idAutorizacion => {
    try {
      // First, get the authorization details
      const response = await this.props.client.query({
        query: getAutorizacionTrabajoByCodigoUnico,
        variables: {
          codigoUnico: idAutorizacion.codigoAuth.toUpperCase(),
        },
        fetchPolicy: 'network-only',
      });
      
      const autorizacion = response.data.getAutorizacionTrabajoByCodigoUnico;
      
      // If authorization found, get the MinioURL
      if (autorizacion && autorizacion._id && autorizacion.urlMinio) {
        try {
          // Fetch MinioURL using the authorization ID
          const minioResponse = await this.props.client.query({
            query: getMinioUrlAutorizacionTrabajo,
            variables: {
              idAutorizacion: autorizacion._id
            },
            fetchPolicy: 'network-only',
          });
          
          // Add MinioURL to the authorization object
          if (minioResponse && minioResponse.data && minioResponse.data.getMinioUrlAutorizacionTrabajo) {
            autorizacion.urlMinio = minioResponse.data.getMinioUrlAutorizacionTrabajo;
            console.log('MinioURL retrieved:', autorizacion.urlMinio);
          } else {
            console.log('No MinioURL available for this authorization');
          }
        } catch (minioError) {
          console.error('Error fetching MinioURL:', minioError);
          // Continue with the process even if MinioURL retrieval fails
        }
      }
      
      return autorizacion;
    } catch (error) {
      console.error('Error fetching authorization:', error);
      this.setState({ error: 'Error al buscar la autorización' });
      return null;
    }
  };

  render() {
    const { loading, error, fase, autorizacionEncontrada } = this.state;
    let componente = null;

    if (loading) {
      return <div>Cargando...</div>;
    }

    if (fase === 0) {
      componente = (
        <>
          <FormVerificacionAutorizacionMenor onSubmit={this.onSubmit} />
          {error && 
            <div style={{ 
              color: 'red', 
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'center',
              marginTop: '20px',
              marginBottom: '20px',
              padding: '15px',
              backgroundColor: '#ffeeee',
              border: '1px solid #ffcccc',
              borderRadius: '4px'
            }}>
          {error}
        </div>
          }
        </>
      );
    } else if (fase === 1) {
      componente = (
        <VisualizarAutorizacionTrabajoMenor
          autorizacionMenor={autorizacionEncontrada}
        />
      );
    }

    return (
      <div className="stepsFormularios">
        <Steps current={fase}>
          <Step title="Ingreso" />
          <Step title="Documento" />
        </Steps>
        {componente}
      </div>
    );
  }
}

// Add withRouter to access URL parameters
export default withRouter(withApollo(FormVerificacionAutorizacionContainer));